module.exports = __webpack_public_path__ + "static/img/m_ai_from.327b1138.png";